module.exports = __webpack_public_path__ + "static/media/info_icon.191e6e76.svg";